import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'VENDAS',
    isTitle: true
  },
  {
    id: 2,
    label: "Dashboard",
    icon: "home",
    link: "/",
  },
  {
    id: 20,
    label: "Chat",
    icon: "message-square",
    link: "/",
    subItems: [
      {
        id: 201,
        label: "Dashboard",
        link: "/telemarketing/chat/dashboard",
        icon: "home",
        parentId: 20,
      },
      {
        id: 202,
        label: "Conversas",
        link: "/telemarketing/chat/conversas",
        icon: "message-square",
        parentId: 20,
      },
      {
        id: 203,
        label: "Atendentes",
        link: "/telemarketing/chat/atendentes",
        icon: "users",
        parentId: 20,
      },
      {
        id: 204,
        label: "Configurações",
        link: "/telemarketing/chat/configuracoes",
        icon: "settings",
        parentId: 20,
      },
    ],
  },
  {
    id: 3,
    label: "Call Center",
    icon: "users",
    subItems: [
      {
        id: 31,
        label: "Projetos",
        icon: "bx-receipt",
        subItems: [
          {
            id: 31,
            label: "Projetos",
            link: "/telemarketing/projetos",
            parentId: 3,
          },
          {
            id: 32,
            label: "Orçamentos",
            link: "/telemarketing/projetos/orcamentos",
            parentId: 3,
          },
          {
            id: 5,
            label: "Documentos Assinaturas",
            link: "/projetos/documentos-assinatura",
            parentId: 3,
          },
          {
            id: 6,
            label: "Configurações",
            link: "/telemarketing/projetos/configuracoes",
            parentId: 3,
          }
        ],
      },
      {
        id: 32,
        label: "Contatos",
        icon: "bx-receipt",
        subItems: [
          {
            id: 8,
            label: "Qualificados",
            link: "/telemarketing/contatos/lista-qualificados",
            parentId: 6,
          },
          {
            id: 9,
            label: "Contatos Gerados",
            link: "/telemarketing/contatos/listas",
            parentId: 6,
          },
          {
            id: 10,
            label: "Gerar contatos",
            link: "/telemarketing/contatos/gerar",
            parentId: 6,
          },
          {
            id: 11,
            label: "Banco de Dados",
            link: "/telemarketing/clientes",
            parentId: 6,
          },

        ],
      },
      // {
      //   id: 60,
      //   label: "WhatsApp",
      //   link:"",
      //   icon: "phone",
      //   subItems: []
      // },
      {
        id: 12,
        label: "Feiras",
        link: "/telemarketing/feiras",
        parentId: 6,
      },
      {
        id: 13,
        label: "Configurações",
        link: "/telemarketing/configuracoes",
        parentId: 6,
      }
    ],
  },
  {
    id: 4,
    label: "Estoque",
    icon: "box",
    subItems: [
      {
        id: 41,
        label: "Ordens de Compra",
        link: "/estoque/ordens-compra",
        parentId: 14,
      },
      {
        id: 42,
        label: "Notas Fiscais",
        link: "/estoque/notas-fiscais",
        parentId: 14,
      },
      {
        id: 43,
        label: "Fornecedores",
        link: "/estoque/fornecedores",
        parentId: 14,
      },
      {
        id: 44,
        label: "Saída Estoque",
        link: "/estoque/saida-estoque",
        parentId: 14,
      },
      {
        id: 45,
        label: "Projetos e Itens",
        link: "/estoque/projeto-itens",
        parentId: 14,
      },
      {
        id: 46,
        label: "Estoque",
        link: "/estoque/produtos",
        parentId: 14,
      },
      {
        id: 146,
        label: "Categoria de Produtos",
        link: "/estoque/categoria-produtos",
        parentId: 14,
      },
    ],
  },
  {
    id: 5,
    label: "Marketing",
    icon: "mail",
    subItems: [
      {
        id: 52,
        label: "Campanhas",
        link: "/email-marketing/campanhas",
        parentId: 5,
      },
      {
        id: 53,
        label: "Emails Bloqueados",
        link: "/email-marketing/emails-bloqueados",
        parentId: 5,
      },
    ]
  },
  {
    id: 8,
    label: "Financeiro",
    icon: "dollar-sign",
    subItems: [
      {
        id: 81,
        label: "Dashboard",
        icon: "chart-line",
        link: "/financeiro/dashboard",
        parentId: 8,
      },
      {
        id: 82,
        label: "Contas",
        icon: "wallet",
        link: "/financeiro/contas",
        parentId: 8,
      },
      {
        id: 83,
        label: "Receitas",
        icon: "trending-up",
        link: "/financeiro/receitas",
        parentId: 8,
      },
      {
        id: 84,
        label: "Despesas",
        icon: "trending-down",
        link: "/financeiro/despesas",
        parentId: 8,
      },
      {
        id: 85,
        label: "Transferências",
        icon: "refresh-cw",
        link: "/financeiro/transferencias",
        parentId: 8,
      },
      {
        id: 86,
        label: "Categorias",
        icon: "tag",
        subItems: [
          {
            id: 861,
            label: "Todas Categorias",
            link: "/financeiro/categorias",
            parentId: 86,
          },
          {
            id: 862,
            label: "Categoria Receitas",
            icon: "book-open",
            link: "/financeiro/receitas/tipos",
            parentId: 86,
          },
          {
            id: 863,
            label: "Categoria Despesas",
            icon: "book-open",
            link: "/financeiro/despesas/plano-gastos",
            parentId: 86,
          },
          {
            id: 864,
            label: "Documento de Origem",
            icon: "book-open",
            link: "/financeiro/origem-documento",
            parentId: 86,
          },
        ],
      },
      {
        id: 87,
        label: "Orçamentos",
        icon: "target",
        link: "/financeiro/orcamentos",
        parentId: 8,
      },
      {
        id: 88,
        label: "Metas",
        icon: "award",
        link: "/financeiro/metas",
        parentId: 8,
      },
      {
        id: 89,
        label: "Tags",
        icon: "hash",
        link: "/financeiro/tags",
        parentId: 8,
      },
      {
        id: 90,
        label: "Relatórios",
        icon: "file-text",
        link: "/financeiro/relatorios",
        parentId: 8,
      },
      {
        id: 892,
        label: "Compras",
        icon: "shopping-cart",
        subItems: [
          {
            id: 891,
            label: "Histórico de Eventos",
            icon: "shopping-cart",
            link: "/financeiro/historico-compra-servico",
            parentId: 892,
          },
          {
            id: 893,
            label: "Histórico Compra Empresa",
            icon: "shopping-cart",
            link: "/financeiro/historico-compra-empresa",
            parentId: 892,
          },
        ],
      },
    ]
  },
  {
    id: 91,
    label: "Blog",
    icon: "book-open",
    link: "/blog",
  },
  {
    id: 9,
    label: "CONFIGURAÇÕES",
    isTitle: true,
  },

  {
    id: 10,
    label: "Administração",
    icon: "sliders",
    link: "/",
    subItems: [
      {
        id: 101,
        label: "Usuários",
        link: "/usuarios",
        parentId: 16,
      },
      // {
      //   id: 104,
      //   label: "Auditoria",
      //   link: "/administracao/auditoria",
      //   parentId: 16,
      // },
      // {
      //   id: 102,
      //   label: "Financeiro",
      //   link: "/",
      //   parentId: 16,
      // },
      {
        id: 103,
        label: "Ajuda",
        link: "/ajuda",
        parentId: 16,
      },
    ],
  },
  
];
